// photosLanding.js
import pm1 from '../Assets/PrintDesigns/print1.png'
import pm2 from '../Assets/PrintDesigns/print2.png'
import pm3 from '../Assets/PrintDesigns/print3.png'
import pm4 from '../Assets/PrintDesigns/print4.png'
import pm5 from '../Assets/PrintDesigns/print5.png'
import pm6 from '../Assets/PrintDesigns/print6.png'
import pm7 from '../Assets/PrintDesigns/print7.png'
import pm8 from '../Assets/PrintDesigns/print8.png'
import pm9 from '../Assets/PrintDesigns/print9.png'
import pm10 from '../Assets/PrintDesigns/print10.png'
import pm11 from '../Assets/PrintDesigns/print11.png'
import pm12 from '../Assets/PrintDesigns/print12.png'
import pm13 from '../Assets/PrintDesigns/print13.png'
import pm14 from '../Assets/PrintDesigns/print14.png'
import pm15 from '../Assets/PrintDesigns/print15.png'
import pm16 from '../Assets/PrintDesigns/print16.png'
import pm17 from '../Assets/PrintDesigns/print17.jpg'
import pm18 from '../Assets/PrintDesigns/print18.png'
import pm19 from '../Assets/PrintDesigns/print19.jpg'
import pm20 from '../Assets/PrintDesigns/print2.png'
import pm21 from '../Assets/PrintDesigns/print20.png'

export const printPhotos = [
  {
    src: pm1,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: pm2,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm3,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm4,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: pm5,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm6,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: pm7,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm8,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm9,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },

  {
    src: pm10,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: pm11,
    width: 1,
    height: 1,
    title: 'Promo',
  },

  {
    src: pm12,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm13,
    width: 1,
    height: 1,
    title: 'Promo',
  },

  {
    src: pm14,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm15,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm16,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: pm17,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },

  {
    src: pm18,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: pm19,
    width: 1,
    height: 1,
    title: 'Promo',
  },

  {
    src: pm20,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: pm11,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: pm21,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },

  {
    src: pm2,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm6,
    width: 1,
    height: 1,
    title: 'Promo',
  },
]
